import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { confirmUnsavedQuizNavigation } from "../utils/unsavedQuizGuard";
import { announceNavigationStart } from "../components/GlobalNavigationFeedback";

export default function useGuardedNavigate() {
  const navigate = useNavigate();

  return useCallback(
    async (to, options) => {
      if (await confirmUnsavedQuizNavigation()) {
        announceNavigationStart(document.activeElement);
        navigate(to, options);
      }
    },
    [navigate]
  );
}
